import React from "react";
import { useTranslation } from "react-i18next";

import { LoginModalFooterProps } from "@models/components/auth.model";

const LoginModalFooter: React.FC<LoginModalFooterProps> = ({ onRegister }) => {
  const { t } = useTranslation();
  return (
    <div className="container">
      <div className="row">
        <div className="col-sm-12">
          <div className="fg-modal-msg-content">
            <p data-testid="youDon'tHaveAccountYet">
              {t("youDontHaveAccountYet")}

              <button
                data-testid="register"
                className="fg-button-override"
                onClick={onRegister}
              >
                {t("register")}
              </button>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginModalFooter;
